import React, { useState, useEffect, Fragment } from "react";
import { CHART_OF_ACCOUNTS, CHARTS_OF_ACCOUNTS, CHARTS_OF_ACCOUNTS_DETAILS } from "../../utils/constants";
import useRequireAuth from "../../utils/useRequireAuth";
import LayoutHOC from "../LayoutHOC";
import Accordion from "./Accordion";
import AddAccount from "./AddAccount";
import { ReactComponent as TransparentBack } from "../../assets/images/transparentBack.svg";
import AssetHeader from "./AssetHeader";
import CustomerListTable from "../customer/CustomerListTable";
import { useLocation } from "react-router-dom";
import { Tooltip } from "@mui/material";
import ChartOfAccountTable from "./ChartOfAccountTable";
import FirstMessage from "../GlobalFeature/MessageAlert/FirstMessage";
import { useDispatch } from "react-redux";
import { pushAlert } from "../../utils/alertSlice";

const AssetList = () => {
  const auth = useRequireAuth();
  const location = useLocation();
  const dispatch = useDispatch();
  const hashValue = location.hash.substring(1);

  const companyLocalData = localStorage.getItem("company_data");
  const parsedCompanyData = JSON.parse(companyLocalData);

  const [data_chatofacc, setChardata] = useState(null);
  const [mainData, setMainData] = useState([]);

  const [accordions, setAccordion] = useState([]);
  const [activeMenu, setActiveMenu] = useState(1);
  const [accordindMenuWiseData, setAccordindMenuWiseData] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);

  const [activeTab, setActiveTab] = useState(hashValue || "#All");

  const [data, setData] = useState([]);
  const [formData, setFormData] = useState({
    account_type: "",
    account_name: "",
    account_number: "",
    sub_account: false,
    descriptions: "",
    balance_as_on_date: "",
    amount: "",
    currency: "",
  });

  const [assetTablePagination, setAssetTablePagination] = useState(`?page=1`);
  const [alert, setAlert] = useState({ visible: false, message: "", type: "" });
  const hideAlert = () => {
    setAlert((prevState) => ({ ...prevState, visible: false }));
  };
  const getTransformedData = (val) => {
    const transformedData = val.map((obj) => {
      let transformedObj = {};

      Object.keys(obj).forEach((key, index) => {
        transformedObj[key] = {
          value: obj[key],
          type: null,
          field_options: null,
          table_name: null,
          field_name: key,
          id: index,
        };
      });

      return transformedObj;
    });

    return transformedData;
  };

  const getFilteredData = (data) => {
    console.warn(data, "asdfgdfxzd");
    switch (activeTab) {
      case "Assets":
        return data.filter((item) => item.account_name === "Assets");
      case "Liabilities":
        return data.filter((item) => item.account_name === "Liabilities");
      case "Equity":
        return data.filter((item) => item.account_name === "Equity");
      case "Income":
        return data.filter((item) => item.account_name === "Income");
      case "Expenses":
        return data.filter((item) => item.account_name === "Expenses");
      default:
        return data; // return all data if no activeTab matches
    }
  };

  const fetchcoaData = async () => {
    try {
      const Authtoken = auth.token;
      const response = await fetch(
        `${CHART_OF_ACCOUNTS}?company_id=${parsedCompanyData?.company_id}&org_id=${auth?.org_id}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${Authtoken}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response?.success || response?.data?.success || response?.data?.status || response?.data?.status) {
        dispatch(pushAlert({ type: "success", message: response?.data?.message, visible: true }));
      } else {
        dispatch(pushAlert({ type: "danger", message: response?.error?.data?.error, visible: true }));
      }
      const data = await response.json();

      let filteredData = getFilteredData(data?.data);

      const transformedData = getTransformedData(filteredData);

      setData(filteredData);
      setChardata(transformedData);
      setMainData(data?.data);

      createaccord(data?.data);
    } catch (error) {
      console.error("Error fetching data:", error);
      setChardata(null);
    }
  };
  const handleClick = (menu) => {
    setActiveMenu(menu);
  };
  useEffect(() => {
    if (auth.token) {
      fetchcoaData();
    }
  }, [auth.token]);

  //console.log(setAccordion)
  /* function generateData(data){
        console.log(data);
    } */

  const generateData = (children) => {
    console.warn(children, "children");
    if (Array.isArray(children)) {
      return (
        <div className="relative overflow-x-auto">
          <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
            <thead className="text-xs text-gray-700 bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <th scope="col" className="bg-E6ECF1 px-6 py-4 text-2C495D text-left font-normal text-base">
                  Code
                </th>
                <th scope="col" className="bg-E6ECF1 px-6 py-4 text-2C495D text-left font-normal text-base">
                  Name
                </th>
                <th scope="col" className="bg-E6ECF1 px-6 py-4 text-2C495D text-left font-normal text-base">
                  Detail Type
                </th>
                <th scope="col" className="bg-E6ECF1 px-6 py-4 text-2C495D text-left font-normal text-base">
                  Balance
                </th>
                <th scope="col" className="bg-E6ECF1 px-6 py-4 text-2C495D text-left font-normal text-base text-center">
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {children.map((child) => (
                <tr key={child.id} className="border-neutral-200">
                  {/* Render table cells for each child */}
                  <td className="whitespace-nowrap border-b border-e border-s text-cyan-600 border-neutral-200 px-6 py-2 font-normal text-left">
                    {child.code}
                  </td>
                  <td className="whitespace-nowrap border-b border-e border-s text-cyan-600 border-neutral-200 px-6 py-2 font-normal text-left">
                    {child.name}
                  </td>
                  <td className="whitespace-nowrap border-b border-e border-s text-cyan-600 border-neutral-200 px-6 py-2 font-normal text-left">
                    {child.detailType}
                  </td>
                  <td className="whitespace-nowrap border-b border-e border-s text-cyan-600 border-neutral-200 px-6 py-2 font-normal text-left">
                    {child.balance}
                  </td>
                  <td className="whitespace-nowrap border-b border-e border-s text-cyan-600 border-neutral-200 px-6 py-2 font-normal text-center">
                    {/* Buttons for each child */}
                    <button>
                      {/* <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="#F16136"
                        className="w-4 h-4"
                      >
                         SVG path for the button
                      </svg> */}
                      <TransparentBack />
                    </button>
                    <button>
                      {/* <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="#F16136"
                        className="w-4 h-4"
                      >
                         SVG path for the button
                      </svg> */}
                      <TransparentBack />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* <CustomerListTable
                    tableDetail={{
                      tableidclass: "fullscreen-table z-customer-45",
                      tableparentidclass: "tableparent",
                      tablename: "",
                      tableHeading: "Customer Table",
                      tablenameclass: "font-medium text-xl text-203C50 capitalize",
                      tableSearch: true,
                      tableFilter: true,
                      tableResizer: true,
                      tableZoom: true,
                      tableheader: true,
                      addbutton: (
                        <Tooltip
                          placement="top"
                          title=" Add Customer"
                          PopperProps={{
                            modifiers: [
                              {
                                name: "offset",
                                options: {
                                  offset: [0, -5],
                                },
                              },
                            ],
                          }}
                          componentsProps={{
                            tooltip: {
                              sx: {
                                backgroundColor: "black",
                                color: "white",
                                boxShadow: "none",
                                height: "23px",
                                display: "flex",
                                alignItems: "center",
                              },
                            },
                          }}
                        >
                          <Link
                            to="/add_customer"
                            className={`tooltip hover:text-254155
                            }`}
                          >
                            <i className="bi bi-plus-lg text-2541558A  hover:text-254155 ">
                             
                            </i>
                          </Link>
                        </Tooltip>
                      ),
                    }}
                    totalData={totalData}
                    multiSelect
                    multiData={multiData}
                    setMultiData={setMultiData}
                    thead={AssetHeader}
                    handlePostThead={handlePostData}
                    tbody={transformedData}
                    tablePaginationData={setCustomerTablePagination}
                    setCustomerPayload={setCustomerPayload}
                    fetchtableBodyData={fetchCustomerTable}
                    customerCommnData={customerCommnData || personTableData}
                    fetchPersonInTable={fetchPersonData}
                    TableFieldUpdate={customerTableFieldUpdate}
                    ExtraFieldAddHeader={handleExtraFieldAddHeader}
                    GetAdditionalField={EditHeaderField}
                    GetAddFieldData={CustomerGetAddField}
                    initialFilter={initialFilter}
                    stickyHeaders={stickyHeaders}
                    handleNavigate={handleNavigate}
                    navigateNameCondition={["customer_display_name", "customer_name"]}
                    refetchCustomerData={refetchCustomerData}
                    activeFilterTab={activeFilterTab}
                    setActiveFilterTab={setActiveFilterTab}
                    isListLoading={customerListLoading || customerListFetching}
                    ExtraFieldComponent={{
                      customer_name: (item, header) => (
                        <CustomerName
                          Item={item}
                          multiData={Object.keys(multiData)}
                          refetchCustomerData={refetchCustomerData}
                        />
                      ),
                      person: (item, header, tableDetail) => {
                        const parsedData = parseJSONValue(item[header.key]);
                        return (
                          <EmailHoverElement
                            ParentId={tableDetail}
                            Data={parsedData}
                            HoverActiveClass={"tablehoverelement"}
                          />
                        );
                      },
                      text: (item, header, tableDetail) => {
                        const parsedData = parseJSONValue(item[header.key]);

                        return (
                          <Fragment>
                            {header?.key !== "customer_name" && (
                              <TextHoverElement
                                ParentId={tableDetail}
                                Data={parsedData}
                                HoverActiveClass={"tablehoverelement"}
                                ClassName={`max-w-[500px]`}
                              />
                            )}
                          </Fragment>
                        );
                      },
                    }}
                  /> */}
        </div>
      );
    }
    // Handle case where children is not an array
    return null;
  };

  const createaccord = (data_chatofacc) => {
    // Accept data_chatofacc as parameter
    if (data_chatofacc) {
      const updatedAccordions = data_chatofacc.map((item) => ({
        key: item.id,
        title: item.account_name,
        data: generateData(item.children),
        isOpen: item.id === 1,
      }));
      setAccordion(updatedAccordions);
    }
  };

  const toggleAccordion = (accordionKey) => {
    const updatedAccordions = accordions.map((accord) => ({
      ...accord,
      isOpen: accord.key === accordionKey ? !accord.isOpen : false,
    }));
    setAccordion(updatedAccordions);
  };

  const handleMenuClick = (menuIndex) => {
    callFunctionAccordingToMenu(menuIndex);
    setActiveMenu((prevActiveMenu) => (prevActiveMenu === menuIndex ? null : menuIndex));
  };

  const callFunctionAccordingToMenu = async (menuIndex) => {
    try {
      const idString = menuIndex.toString();
      const Authtoken = auth.token;

      const response = await fetch(`${CHARTS_OF_ACCOUNTS_DETAILS}${idString}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${Authtoken}`,
          "Content-Type": "application/json",
        },
      });

      // if (!response.ok) {
      //   throw new Error("Failed to fetch data");
      // }
      if (response?.success || response?.data?.success || response?.data?.status || response?.data?.status) {
        dispatch(pushAlert({ type: "success", message: response?.data?.message, visible: true }));
      } else {
        dispatch(pushAlert({ type: "danger", message: response?.error?.data?.error, visible: true }));
      }

      const data = await response.json();
      setAccordindMenuWiseData(data);
    } catch (error) {
      console.error("Error fetching data:", error);
      setChardata(null);
    }
  };

  // const [isOpen, setIsOpen] = useState(false);

  // const openPopup = () => {
  //     setIsOpen(true);
  // };

  // const closePopup = () => {
  //     setIsOpen(false);
  // };

  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const openPopup = () => {
    setIsPopupOpen(true);
  };
  const resetFormData = () => {
    setFormData({
      account_type: "",
      account_name: "",
      account_number: "",
      sub_account: false,
      descriptions: "",
      balance_as_on_date: "",
      amount: "",
      currency: "",
    });
  };

  const closePopup = () => {
    setIsPopupOpen(false);
    resetFormData();
  };

  return (
    <div className="flex-1 bg-F1F6F9 mt-12">
      <div className="pl-3">
        <h5 className="text-lg font-semibold text-1D4469 px-4 capitalize">Chart of Accounts</h5>
      </div>
      <div className=" p-4 justify-between text-2C495D font-poppins text-base font-normal ms-3">
        <div className="flex bg-white p-2 ps-5 gap-x-10">
          <p className="cursor-pointer hover:cursor-wai hover:border-b-2 border-2C495D">Bank Transaction</p>
          <p className="cursor-pointer hover:cursor-wai hover:border-b-2 border-2C495D">App Transaction</p>
          <p className="cursor-pointer hover:cursor-wai hover:border-b-2 border-2C495D">Reciepts</p>
          <p className="cursor-pointer hover:cursor-wai hover:border-b-2 border-2C495D">Reconcil</p>
          <p className="cursor-pointer hover:cursor-wai hover:border-b-2 border-2C495D">Rules</p>
          <p className="border-b-2 border-2C495D cursor-pointer hover:cursor-wai">Chartered Accountants</p>
        </div>
      </div>
      {/* <section>
        <div className="flex">
          <div className="flex  py-3 px-5 ms-1">
            <button
             onClick={() => {
              toggleAccordion(0);
              handleMenuClick(0);
             }}
            type="button"
            className={`px-5 ${activeMenu === 0 ? "text-203C50 font-semibold" : "text-848687"}`}>
              All
            </button>

            <button
              onClick={() => {
                toggleAccordion(1);
                handleMenuClick(1);
              }}
              type="button"
              className={`px-5 ${activeMenu === 1 ? "text-203C50 font-semibold" : "text-848687"}`}
            >
              Assets
            </button>
            <button
              onClick={() => {
                toggleAccordion(2);
                handleMenuClick(2);
              }}
              type="button"
              className={`px-5 ${activeMenu === 2 ? "text-203C50 font-semibold" : "text-848687"}`}
            >
              Lability/Credit Card
            </button>
            <button
              onClick={() => {
                toggleAccordion(3);
                handleMenuClick(3);
              }}
              type="button"
              className={`px-5 ${activeMenu === 3 ? "text-203C50 font-semibold" : "text-848687"}`}
            >
              Income
            </button>
            <button
              onClick={() => {
                toggleAccordion(4);
                handleMenuClick(4);
              }}
              type="button"
              className={`px-5 ${activeMenu === 4 ? "text-203C50 font-semibold" : "text-848687"}`}
            >
              Expenses
            </button>
            <button
              onClick={() => {
                toggleAccordion(5);
                handleMenuClick(5);
              }}
              type="button"
              className={`px-5 ${activeMenu === 5 ? "text-203C50 font-semibold" : "text-848687"}`}
            >
              Equity
            </button>
            <button
              onClick={() => {
                toggleAccordion(6);
                handleMenuClick(6);
              }}
              type="button"
              className={`px-5 ${activeMenu === 6 ? "text-203C50 font-semibold" : "text-848687"}`}
            >
              Archive
            </button>
          </div>
          <div className="box-content flex flex-col justify-center w-14 h-[50px] border-1 border-solid bg-white border-BECBD3">
            <button onClick={openPopup} className="text-center text-288FB2 text-32" type="button">
              +
            </button>
          </div>
        </div>
      </section> */}
      <>
        {isPopupOpen && (
          <AddAccount
            isOpen={isPopupOpen}
            onClose={closePopup}
            tableData={data}
            setData={setData}
            alert={alert}
            setAlert={setAlert}
            formData={formData}
            setFormData={setFormData}
            isEditMode={isEditMode}
            setIsEditMode={setIsEditMode}
          />
        )}
      </>

      <div className="mx-4">
        <ChartOfAccountTable
          data={data}
          setData={setData}
          openPopup={openPopup}
          formData={formData}
          setFormData={setFormData}
          isEditMode={isEditMode}
          setIsEditMode={setIsEditMode}
        />
      </div>

      {/* <div className="m-5 ms-6">
        {accordions.map((accordion) => (
          <Accordion
            key={accordion.key}
            title={accordion.title}
            data={accordion.data}
            isOpen={accordion.isOpen}
            toggleAccordion={() => toggleAccordion(accordion.key)}
          />
        ))}
      </div> */}
    </div>
  );
};

export default LayoutHOC(AssetList);
